<template>
  <div >
    <h1>Управление маршрутами</h1>
    <div class="head-panel">
      <SearchBar @search="handleSearch" />
    
      <StatusFilter @update:status="handleSearchStatus" :initialStatus="status" class="status-filter"/>
    
      <div class="buttons-container">
        <button v-if="!showForm" class="new-button" @click="showForm = true">Добавить новый маршрут</button>

        <UploadRoutes v-if="!showForm"/>

        <button v-if="showForm" class="close-button" @click="showForm = false">Закрыть</button>
      </div>
    </div>

    <NewRouteForm v-if="showForm" @close="showForm = false" />

    <RouteTable v-else 
    :routes="filteredRoutes" 
    @deleteRoute="deleteRoute" 
    @toggleStatus="updateRouteStatus"
    @updateRoute="updateRoute"
    />
  </div>
</template>

<script>
import { ref, computed, onMounted } from "vue";
import { useStore } from "vuex";
import SearchBar from "@/pages/newAti/components/SearchBar";
import RouteTable from "@/pages/newAti/components/RouteTable";
import NewRouteForm from "@/pages/newAti/components/NewRouteForm";
import StatusFilter from "@/pages/newAti/components/StatusFilter";
import UploadRoutes from '@/pages/newAti/components/UploadRoutesFile'

export default {
  components: { SearchBar, RouteTable, NewRouteForm, StatusFilter, UploadRoutes },
  setup() {
    const store = useStore();
    const showForm = ref(false);
    const searchQuery = ref("");

    const filteredRoutes = computed(() => store.state.newAti.filteredRoutes);
    const status = computed(() => store.state.newAti.statusName);
    
    const fetchRoutes = async () => {
      await store.dispatch("newAti/fetchRoutes");
    };

    const updateRouteStatus = async (routes) => {
      await store.dispatch("newAti/updateRouteStatus", routes);
    };

    const updateRoute = async ({routeId, route}) => {
      await store.dispatch("newAti/updateRoute", {routeId, route});
    };

    const deleteRoute = async (routeId) => {
      await store.dispatch("newAti/deleteRoute", routeId);
    };

    const handleSearch = (query) => {
      searchQuery.value = query;
      store.dispatch("newAti/filterRoutes", {searchQuery:query});
    };

    const handleSearchStatus = (query) => {
      searchQuery.value = query;
      store.dispatch("newAti/filterRoutes", {status:query});
    };

    const uploadFile = () => {
      alert("Функция загрузки файла пока не реализована.");
    };

    onMounted(() => {
      fetchRoutes();
    });

    return {
      updateRoute,
      updateRouteStatus,
      showForm,
      searchQuery,
      filteredRoutes,
      handleSearch,
      uploadFile,
      deleteRoute,
      status,
      handleSearchStatus,
    };
  },
};
</script>

<style scoped>
h1{
  margin-top: 20px;
  margin-bottom: 20px;
  text-align: center;
}

.status-filter{
  margin-left: 15px;
}

.head-panel{
  display: flex;
  align-items: center;
}

.buttons-container {
  display: flex;
  gap: 10px;
}

.buttons-container button {
  padding: 10px 15px;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.buttons-container .new-button {
  background-color: rgba(33, 136, 56,0.5);
  
}

.buttons-container .new-button:hover {
  background-color: rgba(33, 136, 56,0.7);
}

.buttons-container .upload-button {
  background-color: rgba(0, 123, 255,0.5);
  
}

.buttons-container .upload-button:hover {
  background-color: rgba(0, 123, 255,0.7);
}

.buttons-container .close-button {
  background-color: rgba(200, 35, 51, 0.5);
}

.buttons-container .close-button:hover {
  background-color: rgba(200, 35, 51, 0.7);
}
</style>